import { Markup } from '@/components/Markup';
import { Tiktok } from './Tiktok';

export const StandaloneTiktok: typeof Markup = (props) => <Tiktok {...props} />;
